import React from 'react'
import { motion } from "motion/react"
import manger from '../../../assets/images/yousefBnAbdallah.png'
const sectionReveal = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.6, ease: 'easeOut' },
  viewport: { once: true, amount: 0.2 },
}
const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
    },
  },
};
const item = {
  hidden: { opacity: 0, y: 24 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

export default function AboutTheConference() {
  return (
    <motion.div
      {...sectionReveal}
      variants={container}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.25 }}
      className='flex flex-wrap flex-col-reverse md:flex-row px-6 md:px-16 py-16 items-center justify-between'
    >
      <div className='md:w-[65%] w-full space-y-2 md:space-y-3'>
        <motion.h2 variants={item} className='font-bold lg:text-4xl text-2xl text-center'>برعاية معالي</motion.h2>
        <motion.h2 variants={item} className='font-bold lg:text-4xl text-2xl text-center'>رئيس مجلس إدارة جامعة الملك سعود</motion.h2>
        <motion.h3 variants={item} className='font-bold lg:text-4xl text-2xl text-center text-[#0084BD]'>الأستاذ. يوسف بن عبد الله البنيان</motion.h3>
        <motion.p variants={item} className='lg:text-2xl text-xl font-bold text-center'>تنظم عمادتي تطوير المهارات والموارد البشرية</motion.p>
        <motion.p variants={item} className='lg:text-2xl text-xl font-bold text-center'>ملتقـــى الجامعة للتدريب</motion.p>
        <motion.p variants={item} className='lg:text-2xl text-xl font-bold text-center'>
          بنسخته الأولى
          «
          تمكين
          <>2026</>
          <>X</>
          »
        </motion.p>
        <motion.p variants={item} className='text-2xl text-center font-bold'>تحت شـــعار:</motion.p>
        <motion.p variants={item} className='text-2xl text-center font-bold bg-gradient-to-r from-[#4D3C7A] to-[#0766A3] bg-clip-text text-transparent'> « مهارتك تصنع مستقبلك »</motion.p>
      </div>
      <motion.div variants={item} className='md:w-[30%] w-full'>
        <img src={manger} alt="manger" className='w-full object-cover' />
      </motion.div>
    </motion.div>
  )
}